/**
 *  Alaska: Editor
 *  Public: Risk Calculator questionnare
 *
 *  @version 1.0
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('RiskCalculator', () => ({
        started: false,
        completed: false,
        showScore: false,
        currentQuestion: 0,
        currentHelperText: null,
        answeredCount: 1,
        openedAnswersImprove: {},
        openedAnswersStrong: {},
        savedResultId: null,

        questions: [
            {
                text: 'How many employees does your organization have?',
                options: [
                    { label: '1-50 employees', score: 3 },
                    { label: '51-200 employees', score: 2 },
                    { label: '201-500 employees', score: 2 },
                    { label: '500+ employees', score: 1 },
                ],
                helperText: 'Businesses with greater numbers of staff tend to have more valuable / attractive targets, making them more susceptible to hacking attempts.',
                answer: null,
            },
            {
                text: 'What do you have in place for desktop / laptop security',
                options: [
                    { label: 'Anti Virus Software', score: 2 },
                    { label: 'Not sure', score: 1 },
                    { label: 'Microsoft Defender', score: 3 },
                    { label: 'Managed Detection and Response', score: 4 },
                ],
                helperText:
                    'In this cyber age, security tools such as firewalls, endpoint security etc produce thousands of alerts.  MDR allows business to filter and investigate alerts, proritise threats and responds to incidents',
                answer: null,
            },
            {
                text: 'Does your desktop / laptop security solution….',
                options: [
                    { label: 'Update itself automatically', score: 3 },
                    { label: 'Have people monitoring breaches and respond to you', score: 4 },
                    { label: 'Not sure', score: 1 },
                    { label: 'Keep popping up annoying alerts?', score: 2 },
                ],
                helperText:
                    'Regular upates are crucial to maintaining a strong cyber security posture against viruses / malware  and threats.  When combined with MDR, this offers a strong security solution.',
                answer: null,
            },
            {
                text: 'How would you describe your IT infrastructure?',
                options: [
                    { label: 'Basic (simple web or cloud services)', score: 4 },
                    { label: 'Moderate (multiple systems, databases, and integrations)', score: 3 },
                    { label: 'Complex (enterprise-level infrastructure with custom applications)', score: 2 },
                    { label: 'Critical Infrastructure (high-security requirements)', score: 1 },
                ],
                helperText:
                    'Complexity in IT can be an attack vector, either from deploying complex solutions in order to protect valuable assets, or because disparate systems are used which can expose weaknesses.  A joined up, managed cyber infrastructure is crucial in repelling attacks.',
                answer: null,
            },
            {
                text: 'Do you have a penetration test done',
                options: [
                    { label: 'Never', score: 1 },
                    { label: 'One-off', score: 2 },
                    { label: 'Annually', score: 3 },
                    { label: 'Quarterly or more regularly?', score: 4 },
                ],
                helperText:
                    'Good practice suggests a penetration test should be done at least once per year.   However, business should also consider running one whenever a major change is implemented.  Penetration Testing as a Service automates this so you get regular reports on your setup and allows you to respond to vulnerabilities quickly.',
                answer: null,
            },
            {
                text: 'Do you need to meet any specific compliance standards?',
                options: [
                    { label: 'ISOs', score: 4 },
                    { label: 'GDPR', score: 3 },
                    { label: 'Cyber Essentials', score: 2 },
                    { label: 'Other', score: 1 },
                ],
                helperText:
                    'The compliance standard your business is measured against generally correlates to the level of cyber spend you should be making.  ISO standard compliance suggests a mature approach to information security, implying strong controls and safeguards should be in place.  In contrast, Cyber Essentials, whilst good, is self-assessed, so is only as good as your answers.',
                answer: null,
            },
            {
                text: 'Are your firewalls proactively managed and patched for you?',
                options: [
                    { label: 'Cloud firewalls managed and patched by an MSP', score: 4 },
                    { label: 'On-premise and managed by us', score: 2 },
                    { label: 'On-premise and managed by an MSP', score: 3 },
                    { label: 'Not sure', score: 1 },
                ],
                helperText:
                    'Business should expect firewwalls to be proactively managed either in house or my an MSP.  The complexities associated with firewall management requires someone focussed on it and ideally accredited by the firewall vendor.  An unmonitored or unmanaged firewall is a signficant security risk for businesses.',
                answer: null,
            },
            {
                text: 'What is your biggest security concern',
                options: [
                    { label: "Not knowing if we're up to date and compliant", score: 2 },
                    { label: 'The potential for business interruption', score: 3 },
                    { label: 'People in our business clicking on things and exposing us to risk, such as ransomware', score: 3 },
                    { label: "Nothing, we're happy we've got everything in place.", score: 1 },
                ],
                helperText:
                    'Businesses see key risks as human considerations, such as phishing and social engineering attacks.  With increasing number of threats, businesses need to ensure they have robust processes in place to manage cyber security effectively, and to assure themselves that all appropriate steps have been taken.  A regular risk analysis will highlight areas of concern to focus on.',
                answer: null,
            },
        ],

        get maxScore() {
            return this.questions.reduce((sum, q) => sum + Math.max(...q.options.map((o) => o.score)), 0);
        },

        get scoreBreakdown() {
            return this.questions.map((q, index) => {
                const maxQuestionScore = Math.max(...q.options.map((o) => o.score));
                const userScore = q.answer?.score || 0;
                const percentage = userScore / maxQuestionScore;

                return {
                    number: index + 1,
                    text: q.text,
                    userScore,
                    maxQuestionScore,
                    percentage,
                    answer: q.answer?.label || null,
                };
            });
        },

        get areasToImprove() {
            return this.scoreBreakdown
                .filter((item) => item.percentage > 0.25 && item.percentage < 0.75)
                .map((item) => {
                    this.openedAnswersImprove[item.number] = true;
                    return item;
                });
        },

        get strongAreas() {
            return this.scoreBreakdown
                .filter((item) => item.percentage >= 0.75)
                .map((item) => {
                    this.openedAnswersStrong[item.number] = true;
                    return item;
                });
        },

        get totalUserScore() {
            return this.questions.reduce((sum, q) => sum + (q.answer?.score || 0), 0);
        },

        get progress() {
            return this.totalUserScore / this.maxScore;
        },

        get lineLength() {
            return 381.14;
        },

        get lineOffset() {
            return this.lineLength * (1 - this.progress);
        },

        get riskLevel() {
            const percentage = this.totalUserScore / this.maxScore;
            if (percentage <= 0.25) return { label: 'High Risk', bg: 'bg-risk-high-bg', text: 'text-risk-high' };
            if (percentage < 0.75) return { label: 'Moderate Risk', bg: 'bg-risk-medium-bg', text: 'text-risk-medium' };
            return { label: 'Low Risk', bg: 'bg-risk-low-bg', text: 'text-risk-low' };
        },

        get isAttentionNeeded() {
            return this.riskLevel.label !== 'Low Risk';
        },

        get isOptionSelected() {
            return this.questions[this.currentQuestion].answer !== null;
        },

        showAnsweredImprove(index) {
            this.openedAnswersImprove[index] = !this.openedAnswersImprove[index];
        },

        showAnsweredStrong(index) {
            this.openedAnswersStrong[index] = !this.openedAnswersStrong[index];
        },

        getColor() {
            if (this.progress <= 0.25) return 'text-risk-high'; // red
            if (this.progress < 0.75) return 'text-risk-medium'; // yellow
            return 'text-risk-low'; // green
        },

        getProgressBarColor(percentage) {
            if (percentage <= 0.25) return 'bg-risk-high'; // red
            if (percentage < 0.75) return 'bg-risk-medium'; // yellow
            return 'bg-risk-low'; // green
        },

        startAssessment() {
            this.started = true;
            this.completed = false;
        },

        toggleHelperText() {
            if (this.currentHelperText === this.questions[this.currentQuestion].helperText) {
                this.currentHelperText = null;
            } else {
                this.currentHelperText = this.questions[this.currentQuestion].helperText;
            }
        },

        selectOption(option) {
            this.questions[this.currentQuestion].answer = option;
        },

        async nextQuestion() {
            if (!this.isOptionSelected) return;
            if (this.currentQuestion < this.questions.length - 1) {
                this.currentQuestion++;
                this.answeredCount++;
                this.currentHelperText = null;
            } else if (this.answeredCount === this.questions.length) {
                this.completed = true;

                const result = await this.saveRiskAssessment();

                if (!result) return;

                setTimeout(() => {
                    this.completed = false;
                    this.showScore = true;
                }, 1000);
            }
        },

        previousQuestion() {
            if (this.currentQuestion > 0) {
                this.currentQuestion--;
                this.answeredCount--;
                this.currentHelperText = null;
            } else {
                this.started = false;
            }
        },

        async saveRiskAssessment() {
            try {
                const res = await fetch('/alaska/public/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        controller: 'Marketing',
                        action: 'saveRiskAssessment',
                        data: {
                            totalUserScore: this.totalUserScore,
                            percentage: this.progress,
                            breakdown: this.questions.map((q, index) => ({
                                questionId: index + 1,
                                question: q.text,
                                answer: q.answer?.label,
                                score: q.answer?.score || 0,
                            })),
                        },
                    }),
                });

                const result = await res.json();

                if (result.type === 'error') {
                    Notification.render(result.message, 'error');
                }

                this.savedResultId = result.id;

                return result;
            } catch (error) {
                console.error(error);
            }
        },

        openContactUsModal() {
            const store = Alpine.store('HtmlModal');
            store.load_html({
                controller: 'Menu',
                action: 'fetch',
                data: {
                    icon: 'fa-user',
                    title: 'Speak to a Security Expert',
                    menu: 'risk_calculator_form',
                },
                payload: { resultId: this.savedResultId },
                callback: (status) => {
                    console.log('Assessment flow complete');
                },
            });
        },
    }));
});
